import { api } from '@/api/client';
import type { LauncherApp } from '@/types/generated';

/**
 * What the nine-dot menu should show.
 *
 * SCOPED TO THE ACTIVE ORGANISATION by the server, so switching employers changes the menu — an
 * owner at one company and a viewer at another are the same person with two different sets of
 * tools. Switching clears the whole query cache (AuthProvider.resetCache), which is what makes
 * that work without anything here needing to know about it.
 */
export async function fetchApps(): Promise<LauncherApp[]> {
  const { data } = await api.get<{ data: LauncherApp[] }>('/apps');
  return data.data;
}
